import { render, staticRenderFns } from "./InvestigationCivilDetails.vue?vue&type=template&id=43809523&"
import script from "./InvestigationCivilDetails.vue?vue&type=script&lang=js&"
export * from "./InvestigationCivilDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VRow})
